var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.5C2.94772 4.5 2.5 4.94772 2.5 5.5V19C2.5 19.5523 2.94772 20 3.5 20H6V4.5H3.5ZM20.15 4.5H18V20H20.15C20.8956 20 21.5 19.3956 21.5 18.65V5.85C21.5 5.10442 20.8956 4.5 20.15 4.5Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 2H16.2C17.1941 2 18 2.80589 18 3.8V20.2C18 21.1941 17.1941 22 16.2 22H7.8C6.80589 22 6 21.1941 6 20.2V3.8C6 2.80589 6.80589 2 7.8 2ZM7.8 3.5C7.63431 3.5 7.5 3.63431 7.5 3.8V20.2C7.5 20.3657 7.63431 20.5 7.8 20.5H16.2C16.3657 20.5 16.5 20.3657 16.5 20.2V3.8C16.5 3.63431 16.3657 3.5 16.2 3.5H7.8ZM11.25 18.5C11.1119 18.5 11 18.6119 11 18.75C11 18.8881 11.1119 19 11.25 19H12.75C12.8881 19 13 18.8881 13 18.75C13 18.6119 12.8881 18.5 12.75 18.5H11.25Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/Devices.99a545ee0187c91abe151c2397fcf8c5.svg";
export { ForwardRef as ReactComponent };